
import React from 'react';
import {
    getFirestore,
    collection,
    getDocs,
    doc,
    getDoc,
    query,
    where
} from 'firebase/firestore';
import {onAuthStateChanged} from 'firebase/auth';
import {auth} from '../auth/firebase';
import PropTypes from 'prop-types';

class SB3ProjectCount extends React.Component {
    state = {
        marketplaceCount: 0,
        therapyCount: 0,
        isCompany: false,
        loading: true
    };

    componentDidMount () {
        this.unsubscribeAuth = onAuthStateChanged(auth, async user => {
            if (!user) {
                this.setState({
                    marketplaceCount: 0,
                    therapyCount: 0,
                    isCompany: false,
                    loading: false
                });

                if (this.props.onCompanyChange) {
                    this.props.onCompanyChange(false);
                }

                return;
            }

            const db = getFirestore();

            let isCompany = false;
            let marketplaceCount = 0;
            let therapyCount = 0;

            /*
             * Check Company status first.
             * Marketplace pill is shown only for Company users.
             */
            try {
                const companyRef = doc(
                    db,
                    'companies',
                    user.uid
                );

                const companySnap =
                    await getDoc(companyRef);

                isCompany = companySnap.exists();

                console.log(
                    '[SB3ProjectCount] Company:',
                    isCompany
                );
            } catch (err) {
                console.error(
                    '[SB3ProjectCount] Company check failed:',
                    err
                );
            }

            /*
             * Count Marketplace projects only for Company users.
             */
            if (isCompany) {
                try {
                  const marketplaceRef = collection(
    db,
    `companies/${user.uid}/sbProducts`
);

const activeMarketplaceQuery = query(
    marketplaceRef,
    where('isDeleted', '==', false)
);

const marketplaceSnapshot =
    await getDocs(activeMarketplaceQuery);

marketplaceCount =
    marketplaceSnapshot.size;

                    console.log(
                        '[SB3ProjectCount] Marketplace count:',
                        marketplaceCount
                    );
                } catch (err) {
                    console.error(
                        '[SB3ProjectCount] Marketplace count failed:',
                        err
                    );
                }
            }

            /*
             * Therapy projects are available to both
             * Profile and Company users.
             */
            try {
                const therapyRef = collection(
                    db,
                    `therapyProjects/${user.uid}/projects`
                );

                const activeTherapyQuery = query(
    therapyRef,
    where('isDeleted', '==', false)
);

const therapySnapshot =
    await getDocs(activeTherapyQuery);

therapyCount =
    therapySnapshot.size;

                console.log(
                    '[SB3ProjectCount] Therapy count:',
                    therapyCount
                );
            } catch (err) {
                console.error(
                    '[SB3ProjectCount] Therapy count failed:',
                    err
                );
            }

            this.setState({
                marketplaceCount,
                therapyCount,
                isCompany,
                loading: false
            });

            /*
             * Pass Company status upward to the parent component.
             */
            if (this.props.onCompanyChange) {
                this.props.onCompanyChange(isCompany);
            }
        });
    }

    componentWillUnmount () {
        if (this.unsubscribeAuth) {
            this.unsubscribeAuth();
        }
    }

    renderPill (title, text) {
        return (
            <div
                title={title}
                style={{
                    marginLeft: '12px',
                    padding: '6px 10px',
                    borderRadius: '999px',
                    background: '#f8fafc',
                    border: '1px solid #0f0f0f',
                    fontSize: '0.75rem',
                    fontWeight: 600,
                    color: '#334155',
                    whiteSpace: 'nowrap'
                }}
            >
                {text}
            </div>
        );
    }

    render () {
        const {
            marketplaceCount,
            therapyCount,
            isCompany,
            loading
        } = this.state;

       return (
    <>
        {this.renderPill(
            'Max 10 saved therapy projects',
            loading ?
                'Therapy: ...' :
                `Therapy: ${therapyCount} / 10`
        )}

        {isCompany && this.renderPill(
            'Max 10 Marketplace products',
            loading ?
                'Marketplace: ...' :
                `Marketplace: ${marketplaceCount} / 10`
        )}
    </>
);
    }
}

SB3ProjectCount.propTypes = {
    onCompanyChange: PropTypes.func
};

export default SB3ProjectCount;

